import React from 'react';
import Icon from '../../../components/AppIcon';

const LoadingState = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {[1, 2, 3, 4, 5, 6]?.map((item) => (
        <div
          key={item}
          className="bg-card rounded-xl shadow-warm overflow-hidden animate-pulse"
        >
          <div className="aspect-[3/4] bg-muted flex items-center justify-center">
            <Icon name="User" size={48} color="var(--color-muted-foreground)" />
          </div>
          <div className="p-4 space-y-3">
            <div className="h-4 bg-muted rounded w-3/4" />
            <div className="h-3 bg-muted rounded w-1/2" />
            <div className="h-3 bg-muted rounded w-full" />
            <div className="flex gap-2">
              <div className="h-8 bg-muted rounded flex-1" />
              <div className="h-8 bg-muted rounded flex-1" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingState;